import { forwardRef, memo, useCallback, useMemo } from 'react';
import { Value } from 'react-phone-number-input';
import ReactPhoneInput from 'react-phone-number-input/input';

import Input, { InputProps } from 'components/Input';

export type PhoneInputProps = Omit<InputProps, 'value' | 'OnChange'> & {
  value?: string;
  onChange?(value: string): void;
};

const PhoneInput = ({ value, onChange, ...props }: PhoneInputProps): JSX.Element => {
  const handleOnChange = useCallback((newValue: Value) => onChange?.(newValue?.toString()), [onChange]);

  return (
    <ReactPhoneInput
      value={value}
      // SOURCE: https://github.com/catamphetamine/react-phone-number-input/issues/75
      smartCaret={false}
      onChange={handleOnChange}
      // @ts-ignore
      inputComponent={useMemo(
        () =>
          forwardRef((inputProps, ref) => (
            <Input
              // @ts-ignore
              ref={ref}
              maxLength={20}
              {...inputProps}
              {...props}
            />
          )),
        [JSON.stringify(props)]
      )}
    />
  );
};

const MemoizedPhoneInput = memo(PhoneInput);

export default MemoizedPhoneInput;
